import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {Recap, RecapsRequest, RecapsResponse} from './types'

export async function apiGetRecaps(params: RecapsRequest): Promise<Recap | null> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const url = new URL(apiData.url, window.location.origin)
  url.searchParams.set('project_number', params.projectNumber.toString())
  url.searchParams.set('owner_type', params.ownerType)
  url.searchParams.set('owner_id', params.ownerIdentifier)

  const {data} = await fetchJSONWith<RecapsResponse>(url.toString(), {
    method: 'GET',
  })

  // Extract the first recap from the array, or return null if none exist
  return data.payload?.scribeRecapsRoute?.recaps?.[0] ?? null
}
